
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Datetime } from "vue-datetime";

@Component({
	components: {
        Datetime: Datetime
	}
})
export default class DisableUser extends Vue {

    @Prop()
    public value: any;

    @Prop()
    public selectedDate: Date;

    @Prop()
    public readonly: boolean = false;

    private dateAtMount: string = null;
    private checkboxValue: boolean = false;
    private showAlert: boolean = false;

    private allowWatcher: boolean = false;
    private confirmedChange: boolean = false; //used to ensure we don't trigger the confirmation if they already accepted

    private mounted(): void {
        this.allowWatcher = false;

        if (this.value !== null && this.value !== "") {
            this.selectedDate = this.value;
            this.checkboxValue = true;
            this.dateAtMount = new Date(this.value).toLocaleString();
        }
        this.allowWatcher = true;
        this.$emit("component-loaded");
    }

    @Watch("selectedDate")
	private updateValue(value): void {
        if (!this.allowWatcher)
            return;

        if (this.selectedDate == null)
            this.selectedDate = this.value;

        if (value !== undefined && value != "") {
            if (new Date(value).toISOString() !== new Date(this.value).toISOString()) {
                this.selectedDate = value;

                if(!this.confirmedChange)
                    this.showAlert = true;
            }
        }
    }

    private setDateTimeNow(): void {
         if(!this.allowWatcher)
            return;
        //Date.now on its own doesn't take timezones offset into account, so this ensures the offset is included
        this.updateValue(new Date(Date.now() - ((new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1));
    }

    @Watch("checkboxValue", {deep: true})
    private checkboxWatcher(value): void {
        if(!this.allowWatcher)
            return;

        if(!value)
		    this.showAlert = true;
    }

    private confirmUpdate(value: boolean): void {
        this.showAlert = false;

        //If we are disabling the user
        if(this.checkboxValue){
            if (value) {
                this.confirmedChange = true;
                this.$emit('input',this.selectedDate);
            } else
                this.selectedDate = this.value
        }else{ //If we are enabling the user
            if(value){
                this.$emit('input',null);
                this.dateAtMount = null;
            }
            else
                this.checkboxValue = true;
        }
    }
}
